export function buildContentfullImageUrl(assetUrl, transformations) {
  if (transformations) {
    return 'https:'+ assetUrl + "?" + transformations + "&fm=webp" + "&q=65";  
  } else {
    return 'https:'+ assetUrl + "?fm=webp" + "&q=65";  
  }
}

export function buildContentfullImageUrlByHeight(assetUrl, height = 'auto', transformations = 'c_limit', format = 'auto') {
  return 'https:'+ assetUrl + "?h="+ height + "&fm=webp" + "&q=65";
}

export function buildContentfullImageUrlByWidth(assetUrl, width = 'auto', transformations = 'c_limit', format = 'auto') {
  return 'https:'+ assetUrl + "?w="+ width + "&fm=webp" + "&q=65";  
}

export function imageContentfullSrc(assetUrl, transformations) {
  return buildContentfullImageUrl(assetUrl, transformations);
}

export function imageContentfullDpr(assetUrl, transformations = '') {
  if (!transformations) {
    return buildContentfullImageUrl(assetUrl);
  }

  return buildContentfullImageUrl(assetUrl, transformations)
}

export function buildContentfullImageUrlForBazaarVoice(assetUrl) {
    return 'https:'+ assetUrl ; 
}

export function buildContentfullImageSrcSet(assetUrl, baseWidth, transformations = 'c_limit', format = 'auto') {
  if (!assetUrl || !baseWidth) return '';
  
  // Define responsive breakpoints and DPR values
  const breakpoints = [
    { width: Math.max(320, Math.floor(baseWidth * 0.5)), dpr: 1 },
    { width: Math.max(480, Math.floor(baseWidth * 0.75)), dpr: 1 },
    { width: baseWidth, dpr: 1 },
    { width: Math.max(320, Math.floor(baseWidth * 0.5)), dpr: 2 },
    { width: Math.max(480, Math.floor(baseWidth * 0.75)), dpr: 2 },
    { width: baseWidth, dpr: 2 }
  ];
  
  const srcSetEntries = breakpoints.map(({ width, dpr }) => {
    const actualWidth = Math.floor(width * dpr);
    const url = buildContentfullImageUrlByWidth(assetUrl, actualWidth, transformations, format);
    return `${url} ${actualWidth}w`;
  });
  
  // Remove duplicates and sort by width
  const uniqueEntries = Array.from(new Set(srcSetEntries)).sort((a, b) => {
    const widthA = parseInt(a.split(' ')[1]);
    const widthB = parseInt(b.split(' ')[1]);
    return widthA - widthB;
  });
  
  return uniqueEntries.join(', ');
}


export default {
  buildContentfullImageUrl,
  buildContentfullImageUrlByHeight,
  buildContentfullImageUrlByWidth,
  imageContentfullDpr,
  imageContentfullSrc,
  buildContentfullImageUrlForBazaarVoice,
  buildContentfullImageSrcSet
};
